import {Injectable} from '@angular/core';

@Injectable()
export class RandomStringService {

  private readonly SEED = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~`!@#$%^&*()_+={}[]:";\'<>?,./|\\';

  constructor() {}

  public randomize(value: any): string {
    return this.randomString(value.toString().length);
  }

  public generate() {
    const string_length = Math.floor(Math.random() * 100);
    let randomstring = '';
    for (let i = 0; i < string_length; i++) {
      const rnum = Math.floor(Math.random() * this.SEED.length);
      randomstring += this.SEED.substring(rnum, rnum + 1);
    }
    return randomstring;
  }

  private randomString(length): string {
    let result = '';
    for (let i = length; i > 0; --i) {
      result += this.SEED[Math.floor(Math.random() * this.SEED.length)];
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/randomstring.service.ts